import React from "react";
import { Capacitor } from "@capacitor/core";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./ui-polish.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import USECONTEXT from "./context";
// Android WebView can resize only its visual viewport when the keyboard opens.
// Keep the existing app shell inside the visible height; browser layout is untouched.
if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add("mk-native");
  const syncViewportHeight = () => {
    const visibleHeight = window.visualViewport?.height || window.innerHeight;
    if (visibleHeight > 0) {
      document.documentElement.style.setProperty("--mk-app-height", `${visibleHeight}px`);
    }
  };
  syncViewportHeight();
  window.addEventListener("resize", syncViewportHeight);
  window.visualViewport?.addEventListener("resize", syncViewportHeight);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
      <USECONTEXT>
        <App />
      </USECONTEXT>
    </BrowserRouter>
);

// Register the app service worker independently from notification permission.
// Firebase reuses this same registration when an authenticated driver enables
// push notifications.
if (!Capacitor.isNativePlatform() && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js", { scope: "/" })
      .catch((error) => {
        console.warn("PWA service worker registration failed.", error);
      });
  });
}